import React from "react";
import Slider from "react-slick";
import adimg from '../images/adimg.png'; // Replace with your actual image path
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../css/AdvertisementType2.css'; // Optional CSS file for styling

// Custom Previous Arrow Component
const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <button className="custom-btn custom-btn-prev" onClick={onClick}>
      &lt;
    </button>
  );
};

// Custom Next Arrow Component
const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <button className="custom-btn custom-btn-next" onClick={onClick}>
      &gt;
    </button>
  );
};

const AdvertisementType2 = () => {
  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };

  const slides = [
    [
      { title: "Samanvay", location: "Mansarovar" },
      { title: "Trimurty", location: "Mansarovar" }
    ],
    [
      { title: "Aashirwad", location: "Mansarovar" },
      { title: "Shubh", location: "Mansarovar" }
    ]
  ];

  return (
    <div className="carousel desk text-center slide mt-3 mainadbx">
      <Slider {...settings}>
        {slides.map((group, index) => (
          <div key={index}>
            <div className="row g-2">
              {group.map((ad, idx) => (
                <div className="col-md-6" key={idx}>
                  <div className="avd-card">
                    <div className="ad-gsc2-mask-container">
                      <img
                        src={adimg}
                        className="target-image"
                        alt="Ad"
                      />
                      <span className="ad-badge">Ad</span>
                    </div>
                    <div className="card-body">
                      <h6 className="card-title ad-slider-text">{ad.title}</h6>
                      <p className="avd-title-text-2 m-0">{ad.location}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default AdvertisementType2;
